import UsuarioStore from '@/store/UsuarioStore';
import config from '../misc/Configuracao';
import { Minuta, IModelo, IProcessoControleGabinete, Processo } from '../modelo';
import webdavApi from './MinutaWebdavApi';

export interface IDadosProcesso {
    processo: Processo;
    minuta: Minuta;
    modelo: IModelo;
    login: string;
    funcaoSignatario?: string
}

class WebdavService {

    async urlWebdav(dadosProcesso: IDadosProcesso) {
        return `ms-word:ofe|u|${await this.urlBasica(dadosProcesso, true)}`;
    }

    public urlHttp(dadosProcesso: IDadosProcesso) {
        return this.urlBasica(dadosProcesso);
    }

    public urlBaixarEditar(dadosProcesso: IDadosProcesso) {
        return this.urlBasica(dadosProcesso,true);
    }

    private async urlBasica(dadosProcesso: IDadosProcesso, edicao: boolean = false) {
        const token = await webdavApi.recuperaTokenMinuta(dadosProcesso.processo.identificadorProcesso, dadosProcesso.minuta.tipo.codigo, UsuarioStore.gabinete, edicao);
        const url = edicao ? config.urlWebDAV : config.urlBaseMinuta;
        const idProc = dadosProcesso.processo.identificadorProcesso;
        const tipoMinuta = dadosProcesso.minuta && dadosProcesso.minuta.tipo && dadosProcesso.minuta.tipo.codigo;
        const modeloId = dadosProcesso.modelo.codigo;
        const numeroProcesso = this.getNumeroProcesso(dadosProcesso.processo);
        const funcaoSig = dadosProcesso.funcaoSignatario;

        return `${url}webdav/ge/${idProc}/${tipoMinuta}/${modeloId}/token/${token}/${numeroProcesso}.docx${funcaoSig?.length > 0 ? '?funcaoSignatario=' + funcaoSig : ''}`;
    }

    // noinspection JSMethodCanBeStatic
    private getNumeroProcesso(processo: Processo) {
        if (processo.classe && processo.numero) {
            return `${processo.classe}-${processo.numero}`;
        } else if (processo.numeroProcesso) {
            return processo.numeroProcesso.replace(/ /g, '');
        } else {
            return '<numeroProcessoNaoEncontrado>';
        }
    }
}

export default new WebdavService();
